import { Component, Inject, OnInit } from '@angular/core';
import { UtilitiesService } from '@app/shared/services/utilities.service';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SHARED_IMPORTS } from '@app/shared/shared.imports';

@Component({
  selector: 'app-dynamic-dialog',
  templateUrl: './dynamic-dialog.component.html',
  styleUrls: ['./dynamic-dialog.component.scss'],
  standalone: true,
  imports: [...SHARED_IMPORTS]
})
export class DynamicDialogComponent implements OnInit {
  submitCssClass = 'bg-success';
  constructor(@Inject(MAT_DIALOG_DATA) public data: any) {}

  ngOnInit() {}

  submit() {
    this.data.service.dialogAction(this.data.action, this.data.data);
  }
}
